import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured product update</div>
            {/* TODO: replace with link newfeed URI */}
            <Link to="/news/2026-aboveground-biomass-data-release">
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    Apr 16, 2026
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Aboveground biomass data for 2000-2025 now available via Earthmover.
                </div>
            </Link>

            <Link to="https://app.earthmover.io/marketplace/69e00e1c21faca8bf36879d2" target="_blank" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Access Data
                </div>
            </Link>
        </>
    );
}
